import { ChevronDoubleRightIcon } from "@heroicons/react/24/outline";
import React from "react";

type Plan = {
  title: string;
  free: string;
  single: string;
  multiple: string;
};

export const PriceList = () => {
  const mainPlans: Plan[] = [
    {
      title: "月額費用",
      free: "16,500円(税込)",
      single: "33,000円(税込)",
      multiple: "66,000円(税込)",
    },
    {
      title: "戦略見える化シート",
      free: "○",
      single: "○",
      multiple: "○",
    },
    {
      title: "学習コンテンツ",
      free: "○",
      single: "○",
      multiple: "○",
    },
    {
      title: "クイズ・経験値機能",
      free: "○",
      single: "○",
      multiple: "○",
    },
    {
      title: "社員招待（無制限）",
      free: "○",
      single: "○",
      multiple: "○",
    },
    {
      title: "ダッシュボード",
      free: "○",
      single: "○",
      multiple: "○",
    },
    {
      title: "カスタムフォーム",
      free: "○",
      single: "○",
      multiple: "○",
    },
    {
      title: "タスク管理",
      free: "○",
      single: "○",
      multiple: "○",
    },
    {
      title: "評価シート",
      free: "○",
      single: "○",
      multiple: "○",
    },
    {
      title: "いつでもチャット",
      free: "○",
      single: "○",
      multiple: "○",
    },
    {
      title: "経営の最新情報",
      free: "○",
      single: "○",
      multiple: "○",
    },
    {
      title: "各種分析ツール",
      free: "○",
      single: "○",
      multiple: "○",
    },
    {
      title: "AIアシスタント機能",
      free: "×",
      single: "○",
      multiple: "○",
    },
    {
      title: "各セミナー・勉強会参加",
      free: "○",
      single: "○",
      multiple: "○",
    },
    {
      title: "学習サポート",
      free: "×",
      single: "×",
      multiple: "○(5人まで)",
    },
    {
      title: "オンライン研修",
      free: "×",
      single: "×",
      multiple: "○",
    },
    {
      title: "導入設定",
      free: "オプション",
      single: "オプション",
      multiple: "オプション",
    },
  ];

  const fleePlans = [
    {
      title: "月額費用",
      content: "0円",
    },
    {
      title: "戦略見える化シート",
      content: "○（編集・プレビューのみ）",
    },
    {
      title: "学習コンテンツ",
      content: "○（1日1コンテンツ）",
    },
    {
      title: "クイズ・経験値機能",
      content: "×",
    },
    {
      title: "社員招待（無制限）",
      content: "×",
    },
    {
      title: "ダッシュボード",
      content: "×",
    },
    {
      title: "カスタムフォーム",
      content: "×",
    },
    {
      title: "タスク管理",
      content: "×",
    },
    {
      title: "ステップアップシート",
      content: "×",
    },
    {
      title: "いつでもチャット",
      content: "×",
    },
    {
      title: "経営の最新情報",
      content: "○",
    },
    {
      title: "各種分析ツール",
      content: "×",
    },
    {
      title: "各種AIツール",
      content: "×",
    },
    {
      title: "各セミナー・勉強会参加",
      content: "○",
    },
    {
      title: "学習サポート",
      content: "×",
    },
    {
      title: "オンライン研修",
      content: "×",
    },
    {
      title: "導入サポート",
      content: "×",
    },
    {
      title: "財務分析",
      content: "×",
    },
    {
      title: "伴走支援",
      content: "×",
    },
  ];

  const PlanItem = ({ title }: { title: string }) => {
    return (
      <dd className={"text-center py-3 border-b border-r border-gray-200"}>
        {title}
      </dd>
    );
  };

  return (
    <div className={"mb-5"}>
      <div className={"mb-10 overflow-auto"}>
        <div className={""}>
          <dl className={"grid grid-cols-2"}>
            <dt className={"border-b border-gray-200"} />
            <dt
              className={`rounded-tr-3xl rounded-tl-3xl text-center h-12 py-3 border-b border-gray-200 bg-gray-100`}
            >
              無料プラン
            </dt>
          </dl>
          {fleePlans.map((plan, index) => (
            <dl key={index} className={"grid grid-cols-2"}>
              <dt
                className={
                  "bg-gray-50 text-center p-3 border-b border-l border-r border-gray-200"
                }
              >
                {plan.title}
              </dt>
              <PlanItem title={plan.content} />
            </dl>
          ))}
        </div>
      </div>

      <div className={"mb-1 overflow-auto"}>
        <div className={"w-[680px] md:w-full"}>
          <dl className={"grid grid-cols-4"}>
            <dt className={"border-b border-gray-200"} />
            <dt
              className={`rounded-tr-3xl rounded-tl-3xl text-center h-12 py-3 border-b border-gray-200 font-bold bg-[#08296c] text-white`}
            >
              エントリー
            </dt>
            <dt
              className={`rounded-tr-3xl rounded-tl-3xl text-center h-12 py-3 border-b border-gray-200 font-bold bg-[#D27334] text-white`}
            >
              スタンダード
            </dt>
            <dt
              className={`rounded-tr-3xl rounded-tl-3xl text-center h-12 py-3 border-b border-gray-200 font-bold bg-[#A4903D] text-white`}
            >
              アドバンス
            </dt>
          </dl>
          {mainPlans.map((plan, index) => (
            <dl key={index} className={"grid grid-cols-4"}>
              <dt
                className={
                  "bg-gray-50 text-center p-3 border-b border-l border-r border-gray-200"
                }
              >
                {plan.title}
              </dt>
              <PlanItem title={plan.free} />
              <PlanItem title={plan.single} />
              <PlanItem title={plan.multiple} />
            </dl>
          ))}
        </div>
      </div>
      <p className={"text-sm mt-2 flex md:hidden"}>
        スクロールできます
        <ChevronDoubleRightIcon className={"w-4 ml-1"} />
      </p>
    </div>
  );
};
